<template>
    <div id="page" class="new-trademark-registration-page closed-mobile-header">
        <div class="menu-close-toggle hamburger-close-bg-enable hamburger-close-bg-hover-enable hamburger-close-border-enable hamburger-close-border-hover-enable">
            <div class="close-line-wrap"><span class="close-line"></span><span class="close-line"></span><span class="close-line"></span></div>
        </div>

        <div class="mobile-header-space"></div>

        <Header></Header>

        <div id="main" class="sidebar-none sidebar-divider-vertical" style="padding-top:0px;padding-bottom:0px;">
            <div class="main-gradient"></div>
            <div class="wf-wrap">
                <div class="wf-container-main">
                    <div class="uspto-wrap top-sec">
                        <section id="USPTO"
                                 style="background-image:url(&quot;&quot;);background-repeat:no-repeat;background-size:cover;">
                            <h2 style="font-size:2.5em;">Search USPTO <span style="font-weight:500;">Filed Trademarks for Free</span>
                            </h2>
                            <h3 style="font-weight:400;">Our <span style="color:orange;">TM Search</span> finds exact
                                matches with the USPTO</h3>
                            <form id="uspto-form1" action="" method="POST">
                                <div class="search-input-wrap">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                    <input v-model="q" type="text" name="search" placeholder="Enter Name" required="required" autofocus="" class="lazyloaded">
                                </div>
                                <div class="submit-btn">
                                    <div class="submit-left"></div>
                                    <input type="submit" @click.prevent="runSearch" value="SEARCH">
                                    <div class="submit-right"></div>
                                </div>
                            </form>
                            <h4 style="text-transform:uppercase;display:flex;justify-content:center;align-items:center;flex-wrap:wrap;font-weight:800;letter-spacing:.2em;font-size:1.2em;margin-top:20px;color:orange;">
                                Search <i class="fa fa-circle" aria-hidden="true"></i> Apply <i class="fa fa-circle"
                                                                                                aria-hidden="true"></i>
                                Own<sup style="color:#9b9b9b;letter-spacing:0;font-size:.5em;">TM</sup></h4>
                        </section>
                    </div>

                    <div class="wrap-iframes">
                        <template v-if="search_status_uspto">
                            <h1 class="has-text-weight-semibold h1-behind-iframe" style="display: flex; justify-content: space-between; align-items: center;">
                                <span>USPTO Pending, Issued, and Abandoned Applications and Registrations</span>
                            </h1>
                            <section class="uspto-block table-results">
                                <div class="wrapper">
                                    <div class="sort-by">
                                        <div class="MuiBox-root css-0"></div>
                                        <h5 style="float: right;">Displaying mark <span>{{ maxPerPage * (page - 1) + 1}} – {{ maxPerPage * page }}</span> of
                                            <span>{{ totalResults }}</span> in total</h5></div>
                                    <table class="desktop">
                                        <thead>
                                        <tr class="header">
                                            <th>trademark</th>
                                            <th>owner</th>
                                            <th>Serial Number</th>
                                            <th>filing date</th>
                                            <th>STATUS</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="trademark in trademarks">
                                                <td class="title"><p
                                                    class="MuiTypography-root MuiTypography-body1 css-9l3uo3"
                                                    style="font-family: MontserratBold; font-size: 14px; cursor: pointer;">
                                                    <a class="uspto-a" :href="'https://tsdr.uspto.gov/#caseNumber=' + trademark.serialNumber + '&caseSearchType=US_APPLICATION&caseType=DEFAULT&searchType=statusSearch'">{{ trademark.markIdentification }}</a>
                                                </p></td>
                                                <td class="owner">{{ trademark.owners.length > 0 ? trademark.owners[0]['partyName'] : '' }}</td>
                                                <td>{{ trademark.serialNumber }}</td>
                                                <td>{{ trademark.filingDate }}</td>
                                                <td class="status" :class="trademark.liveOrDeadStatus.toLowerCase()"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="mobile">
                                        <tbody>
                                            <tr v-for="trademark in trademarks">
                                                <td>
                                                    <div class="title"><p
                                                        class="MuiTypography-root MuiTypography-body1 css-9l3uo3"
                                                        style="font-family: MontserratBold; font-size: 14px; cursor: pointer;">
                                                        <a class="uspto-a" :href="'https://tsdr.uspto.gov/#caseNumber=' + trademark.serialNumber + '&caseSearchType=US_APPLICATION&caseType=DEFAULT&searchType=statusSearch'">{{ trademark.markIdentification }}</a>
                                                    </p></div>
                                                    <div class="owner">{{ trademark.owners.length > 0 ? trademark.owners[0]['partyName'] : '' }}</div>
                                                    <div class="one-line">
                                                        <div class="filing-date">{{ trademark.filingDate }}</div>
                                                        <div class="status" :class="trademark.liveOrDeadStatus.toLowerCase()"></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="paging">
                                        <div class="wrapper">
                                            <nav aria-label="pagination navigation"
                                                 class="MuiPagination-root MuiPagination-text css-0">
                                                <vue-awesome-paginate
                                                    :total-items="totalResults"
                                                    :items-per-page="10"
                                                    :max-pages-shown="5"
                                                    v-model="page"
                                                    :on-click="changePage"
                                                />
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </template>
                        <section v-if="search_status_bing">
                            <h1 class="has-text-weight-semibold h1-behind-iframe" style="display: flex; justify-content: space-between; align-items: center;">
                                <span>Internet Search of Similar Third Party Uses</span>
                                <button @click="backBing" class="button is-warning" type="button" title="Click to go back to search results.">Back</button>
                            </h1>
                            <iframe class="bing-iframe common-iframe" :src="'https://www.bing.com/search?q=' + search_q"></iframe>
                        </section>
                    </div>

                </div>
            </div>
        </div>
            <BottomFixBlock
                text="File Your Trademark Application"
                url="/trademark-registration-process"
            ></BottomFixBlock>
            <Footer></Footer>
    </div>
</template>

<script>
import BottomFixBlock from '@/components/blocks/BottomFixBlock.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import {to_top} from "@/helper";
import http from "@/api/http";

export default {
    components: {
        BottomFixBlock,
        Header,
        Footer
    },
    data() {
        return {
            page: 1,
            maxPerPage: 0,
            totalPages: 0,
            totalResults: 0,
            q: '',
            trademarks: [],
            search_q: '',
            search_status_uspto: false,
            search_status_bing: false,
        }
    },
    mounted() {
        to_top()
    },
    methods: {
        async changePage(page) {
            this.page = page

            let { data } = await http.get('https://innova-labs.net:9094/trademarks/search', {
                params: {
                    name: this.search_q,
                    page: this.page,
                    count: 10
                }
            });

            this.trademarks = data.data.elements
            this.maxPerPage = data.data.maxPerPage
            this.totalPages = data.data.totalPages
            this.totalResults = data.data.totalResults
        },
        async runSearch() {
            if (!this.q) {
                return
            }
            this.trademarks = []
            this.page = 1
            this.search_status_uspto = false
            this.search_status_bing = false

            this.search_q = this.q
            this.search_status_bing = true

            let { data } = await http.get('https://innova-labs.net:9094/trademarks/search', {
                params: {
                    name: this.search_q,
                    page: this.page,
                    count: 10
                }
            });


            this.trademarks = data.data.elements
            this.maxPerPage = data.data.maxPerPage
            this.totalPages = data.data.totalPages
            this.totalResults = data.data.totalResults
            this.search_status_uspto = true
        },
        async backBing() {
            this.search_status_bing = false
            this.$nextTick(() => {
                this.search_status_bing = true
            });
        },
    }
}
</script>

<style scoped>
.uspto-a {
    color: rgb(0, 193, 207) !important;
}
.wrap-iframes {
    max-width: 100%;
    margin: 0 auto;
    padding: 0 50px 0 50px;
    width: 1480px;
}
.common-iframe {
    width: 100%;
    height: 500px;
    border: 1px solid;
}
.bing-iframe {
    margin-bottom: 20px;
}
.domain-iframe {

}
/*! CSS Used from: https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/optimized/rev-bd17d78/www.cohnlg.com/combinedCss/nitro-min-noimport-c0ca60af0182b0709615a000fb893368-stylesheet.css */
.fa{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;line-height:1;}
.fa-circle:before{content:"ï„‘";}
.fa-search:before{content:"ï€‚";}
.fa{font-family:Font Awesome\ 5 Free;}
.fa{font-weight:900;}
.fa{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;line-height:1;}
.fa-circle:before{content:"ï„‘";}
.fa-search:before{content:"ï€‚";}
.fa{font-family:"Font Awesome 5 Free";font-weight:900;}
section{display:block;}
*{padding:0;margin:0;}
sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline;}
sup{top:-.5em;}
form{margin:0;}
input{font-size:100%;margin:0;vertical-align:baseline;}
input{line-height:normal;}
input[type=submit]{cursor:pointer;-webkit-appearance:button;}
h2,h3,h4{margin-bottom:10px;clear:both;font-size: 44px}
h3 {
    font-size: 25px!important;
}
input[type=text]:not(.elementor-field):not(.searchform-s){margin-bottom:10px;border-style:solid;box-sizing:border-box;}
input[type=text]{-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;outline:0;}
input[type=submit]{position:relative;display:inline-block;text-decoration:none;white-space:nowrap;-webkit-tap-highlight-color:transparent;}
input[type=submit]:hover{text-decoration:none;}
.fa{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;line-height:1;}
.fa-circle:before{content:"ï„‘";}
.fa-search:before{content:"ï€‚";}
.fa{font-family:"Font Awesome 5 Free";}
.fa{font-weight:900;}
#page .fa{font-family:"Font Awesome 5 Free";font-weight:900;}
#page .fa:before{font-weight:inherit;}
h2{color:#333;font:normal 600 42px/48px "Arial",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
h3{color:#333;font:normal 700 24px/34px "Roboto",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
h4{color:#333;font:normal 500 20px/30px "Roboto",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
h2,h3,h4{color:#333;}
input[type="submit"]:not([name="update_cart"]){box-shadow:0px 0px 10px 0px rgba(0,0,0,0);transition:all .3s ease-out;}
input[type="submit"]:not([name="update_cart"]):hover{box-shadow:0px 0px 10px 0px rgba(0,0,0,0);}
input[type="submit"]:not([name="update_cart"]){color:#fff;background-color:#45d9e6;background:#45d9e6;background:);}
input[type="submit"]:not([name="update_cart"]):hover{color:#fff;border-color:#45d9e6;}
#page input[type="submit"]:not([name="update_cart"]):hover{background:#23aadd;background:-webkit-linear-gradient(135deg,#23aadd 30%,#37ce9d 100%);background:linear-gradient(135deg,#23aadd 30%,#37ce9d 100%);}
input[type="text"]{color:#8b8d94;border-top-width:1px;border-right-width:1px;border-bottom-width:1px;border-left-width:1px;padding:5px 15px 5px 15px;border-color:rgba(51,51,51,.12);background-color:#fdfdfd;border-radius:1px;}
input[type="text"]{height:38px;}
input[type="submit"]:not([name="update_cart"]):not(.woocommerce-widget-layered-nav-dropdown__submit){font:normal 700 14px/16px "Roboto",Helvetica,Arial,Verdana,sans-serif;text-transform:none;border-radius:var(--the7-medium-button-border-radius);padding:12px 18px 12px 18px;min-height:38px;line-height:38px;padding-top:0;padding-bottom:0;}
input[type="text"]{font:normal 14px/25px "Lato",Helvetica,Arial,Verdana,sans-serif;font-size:14px;}
/*! CSS Used from: Embedded */
input[type="text"]{border-top:none;border-right:none;border-left:none;background-color:#fff;border-width:2px;border-color:#222;}
#page input[type="text"]{font-size:15px;font-height:18px;}
input[type="text"]{color:#333;font-size:15px;}
input[type="text"]{font:normal 300 16px/20px "Nunito",Helvetica,Arial,Verdana,sans-serif;}
input[type="submit"]:not([name="update_cart"]){color:#1fc6c1;background-color:#fff;}
input[type="text"]{color:#222;}
input[type="submit"]:not([name="update_cart"]){padding:9px 60px 9px 60px;min-height:50px;}
/*! CSS Used from: Embedded */
.uspto-wrap{width:100%;display:flex;justify-content:center;}
.top-sec{padding-top:80px;}
#USPTO{display:flex;flex-direction:column;align-items:center;width:100%;}
#USPTO form{display:flex;max-width:900px;width:100%;justify-content:space-evenly;align-items:center;padding:30px 0px;}
.search-input-wrap{width:70%;position:relative;}
.search-input-wrap i{position:absolute;font-size:22px;top:calc(50% - 11px);left:25px;color:#9b9b9b;}
#USPTO form input[type="text"]{width:100%;padding-left:80px;margin:0;border:1px solid black;height:67px;font-size:1.25em;}
.submit-btn{width:25%;height:67px;background:transparent;border-radius:0;border-width:0px;border-style:solid;border-color:black;transition:.5s;position:relative;}
#USPTO form input[type="submit"]{position:absolute;top:0;left:0;z-index:2;height:100%;width:100%;color:black;background:transparent;border:0px solid black;border-radius:0;border-style:solid;border-color:black;transition:.5s;font-size:1.15em;}
#USPTO form input[type="submit"]:hover{background:orange!important;color:white;}
.submit-left,.submit-right{z-index:1;position:absolute;top:0;background-color:transparent;height:calc(100% - 4px);width:20px;border-bottom:2px solid orange;border-top:2px solid orange;}
.submit-left{border-left:2px solid orange;left:0;}
.submit-right{border-right:2px solid orange;right:0;}
h4 .fa-circle{font-size:.5em;margin:0 10px;color:#44d9e6;}
@media only screen and (max-width: 1023px){
    .search-input-wrap{width:100%;}
    .submit-btn{width:50%;margin-top:20px;}
    #USPTO form{flex-direction:column;}
}
/*! CSS Used fontfaces */
@font-face{font-family:Font Awesome\ 5 Free;font-style:normal;font-weight:400;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/plugins/blog-designer//admin/fonts/fa-regular-400.woff2") format("woff2");font-display:swap;}
@font-face{font-family:Font Awesome\ 5 Free;font-style:normal;font-weight:900;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/plugins/blog-designer//admin/fonts/fa-solid-900.woff2") format("woff2");font-display:swap;}
@font-face{font-family:Font Awesome\ 5 Free;font-style:normal;font-weight:400;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/plugins/blog-designer//admin/fonts/fa-regular-400.woff2") format("woff2");font-display:swap;}
@font-face{font-family:Font Awesome\ 5 Free;font-style:normal;font-weight:900;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/plugins/blog-designer//admin/fonts/fa-solid-900.woff2") format("woff2");font-display:swap;}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-bd17d78/www.cohnlg.com/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-solid-900.woff2") format("woff2");}

.fa-search::before {
    content: "";
}
.fa-circle::before {
    content: "";
}

/*! CSS Used from: https://cdnjs.cloudflare.com/ajax/libs/bulma/0.9.3/css/bulma.min.css */
.button{-moz-appearance:none;-webkit-appearance:none;align-items:center;border:1px solid transparent;border-radius:4px;box-shadow:none;display:inline-flex;font-size:1rem;height:2.5em;justify-content:flex-start;line-height:1.5;padding-bottom:calc(.5em - 1px);padding-left:calc(.75em - 1px);padding-right:calc(.75em - 1px);padding-top:calc(.5em - 1px);position:relative;vertical-align:top;}
.button:active,.button:focus{outline:0;}
.button{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
h1{margin:0;padding:0;}
h1{font-size:100%;font-weight:400;}
button{margin:0;}
*,::after,::before{box-sizing:inherit;}
button{font-family:BlinkMacSystemFont,-apple-system,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",Helvetica,Arial,sans-serif;}
span{font-style:inherit;font-weight:inherit;}
.button{background-color:#fff;border-color:#dbdbdb;border-width:1px;color:#363636;cursor:pointer;justify-content:center;padding-bottom:calc(.5em - 1px);padding-left:1em;padding-right:1em;padding-top:calc(.5em - 1px);text-align:center;white-space:nowrap;}
.button:hover{border-color:#b5b5b5;color:#363636;}
.button:focus{border-color:#485fc7;color:#363636;}
.button:focus:not(:active){box-shadow:0 0 0 .125em rgba(72,95,199,.25);}
.button:active{border-color:#4a4a4a;color:#363636;}
.button.is-warning{background-color:#ffe08a;border-color:transparent;color:rgba(0,0,0,.7);}
.button.is-warning:hover{background-color:#ffdc7d;border-color:transparent;color:rgba(0,0,0,.7);}
.button.is-warning:focus{border-color:transparent;color:rgba(0,0,0,.7);}
.button.is-warning:focus:not(:active){box-shadow:0 0 0 .125em rgba(255,224,138,.25);}
.button.is-warning:active{background-color:#ffd970;border-color:transparent;color:rgba(0,0,0,.7);}
.content h1{color:#363636;font-weight:600;line-height:1.125;}
.content h1{font-size:2em;margin-bottom:.5em;}
.has-text-weight-semibold{font-weight:600!important;}
/*! CSS Used from: Embedded */
#tf-search h1{margin:25px 0;padding:10px;border:1px solid;color:#166d97;font-size:18px;text-align:left;}

.h1-behind-iframe {
    padding: 20px;
    border: 1px solid;
}
.h1-behind-iframe span{
    font: normal 700 24px / 34px "Roboto", Helvetica, Arial, Verdana, sans-serif;
    text-transform: none;
}

/*! CSS Used from: https://cdnjs.cloudflare.com/ajax/libs/bulma/0.9.3/css/bulma.min.css */
.pagination-next,.pagination-previous{-moz-appearance:none;-webkit-appearance:none;align-items:center;border:1px solid transparent;border-radius:4px;box-shadow:none;display:inline-flex;font-size:1rem;height:2.5em;justify-content:flex-start;line-height:1.5;padding-bottom:calc(.5em - 1px);padding-left:calc(.75em - 1px);padding-right:calc(.75em - 1px);padding-top:calc(.5em - 1px);position:relative;vertical-align:top;}
.pagination-next:active,.pagination-next:focus,.pagination-previous:active,.pagination-previous:focus{outline:0;}
.pagination-previous[disabled]{cursor:not-allowed;}
.pagination-next,.pagination-previous{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
ul{margin:0;padding:0;}
ul{list-style:none;}
button{margin:0;}
*,::after,::before{box-sizing:inherit;}
button{font-family:BlinkMacSystemFont,-apple-system,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",Helvetica,Arial,sans-serif;}
.content ul{list-style:disc outside;margin-left:2em;margin-top:1em;}
.pagination{font-size:1rem;margin:-.25rem;}
.pagination,.pagination-list{align-items:center;display:flex;justify-content:center;text-align:center;}
.pagination-next,.pagination-previous{font-size:1em;justify-content:center;margin:.25rem;padding-left:.5em;padding-right:.5em;text-align:center;}
.pagination-next,.pagination-previous{border-color:#dbdbdb;color:#363636;min-width:2.5em;}
.pagination-next:hover,.pagination-previous:hover{border-color:#b5b5b5;color:#363636;}
.pagination-next:focus,.pagination-previous:focus{border-color:#485fc7;}
.pagination-next:active,.pagination-previous:active{box-shadow:inset 0 1px 2px rgba(10,10,10,.2);}
.pagination-previous[disabled]{background-color:#dbdbdb;border-color:#dbdbdb;box-shadow:none;color:#7a7a7a;opacity:.5;}
.pagination-next,.pagination-previous{padding-left:.75em;padding-right:.75em;white-space:nowrap;}
.pagination-list{flex-wrap:wrap;}
@media screen and (max-width:768px){
    .pagination{flex-wrap:wrap;}
    .pagination-next,.pagination-previous{flex-grow:1;flex-shrink:1;}
}
@media screen and (min-width:769px),print{
    .pagination-list{flex-grow:1;flex-shrink:1;justify-content:flex-start;order:1;}
    .pagination-next,.pagination-previous{margin-bottom:0;margin-top:0;}
    .pagination-previous{order:2;}
    .pagination-next{order:3;}
    .pagination{justify-content:space-between;margin-bottom:0;margin-top:0;}
}
/*! CSS Used from: https://cdn.jsdelivr.net/npm/bootstrap@5.1.1/dist/css/bootstrap.min.css */
*,::after,::before{box-sizing:border-box;}
h5{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2;}
h5{font-size:1.25rem;}
p{margin-top:0;margin-bottom:1rem;}
ul{padding-left:2rem;}
ul{margin-top:0;margin-bottom:1rem;}
svg{vertical-align:middle;}
table{caption-side:bottom;border-collapse:collapse;}
th{text-align:inherit;text-align:-webkit-match-parent;}
tbody,td,th,thead,tr{border-color:inherit;border-style:solid;border-width:0;}
button{border-radius:0;}
button:focus:not(:focus-visible){outline:0;}
button{margin:0;font-family:inherit;font-size:inherit;line-height:inherit;}
button{text-transform:none;}
[type=button],button{-webkit-appearance:button;}
[type=button]:not(:disabled),button:not(:disabled){cursor:pointer;}
/*! CSS Used from: https://trademark-genius.com/_next/static/css/46a3f9e64458ac06.css */
*,:after,:before{box-sizing:border-box;}
h5{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2;}
h5{font-size:1.25rem;}
p{margin-top:0;margin-bottom:1rem;}
ul{padding-left:2rem;}
ul{margin-top:0;margin-bottom:1rem;}
svg{vertical-align:middle;}
table{caption-side:bottom;border-collapse:collapse;}
th{text-align:inherit;text-align:-webkit-match-parent;}
tbody,td,th,thead,tr{border:0 solid;border-color:inherit;}
button{border-radius:0;}
button:focus:not(:focus-visible){outline:0;}
button{margin:0;font-family:inherit;font-size:inherit;line-height:inherit;}
button{text-transform:none;}
[type=button],button{-webkit-appearance:button;}
[type=button]:not(:disabled),button:not(:disabled){cursor:pointer;}
button,p{font-family:Open SansVariable;}
p,ul li{font-size:18px;}
ul{padding-left:20px;}
.header{vertical-align:top;background-color:#fff;margin:0 auto;text-align:center;padding-top:20px;padding-bottom:20px;}
@media (max-width:800px){
    .header{padding-left:10px;text-align:left;padding-top:10px;padding-bottom:10px;}
}
p{font-family:MontserratRegular;font-style:normal;}
p{font-size:14px;line-height:24px;}
.table-results h5{display:inline-block;color:#394149;font-family:MontserratBold;font-size:12px;line-height:15px;text-transform:uppercase;}
.table-results h5 span{color:#f37217;}
.table-results .sort-by .MuiBox-root{width:242px;display:inline-flex;margin-left:18px;}
.table-results table{margin-top:36px;}
.table-results table .header{border-top:2px solid #ecedf1;border-bottom:2px solid #ecedf1;padding:15px 0;height:56px;vertical-align:middle;}
.table-results table th{color:#7b848d;font-family:MontserratBold;font-size:12px;line-height:15px;text-transform:uppercase;}
.table-results table tr{border-bottom:1px solid #ecedf1;}
.table-results table th:last-child,.table-results table th:nth-last-child(2),.table-results table th:nth-last-child(3){width:6%;}
.table-results table th:nth-last-child(4),.table-results table th:nth-last-child(5){width:15%;}
.table-results table td{text-align:center;padding:20px 10px;}
.table-results .title{color:#03589c;font-family:MontserratBold;cursor:pointer;}
.table-results .owner,.table-results .title{font-size:14px;line-height:24px;text-align:center;}
.table-results .owner{color:#394149;font-family:MontserratRegular;}
.table-results .status.live{background:url(https://trademark-genius.com/_next/static/media/Live.3dd94541.png) no-repeat 50%;}
.table-results .status.dead{background:url(https://trademark-genius.com/_next/static/media/Dead.a0f83ed0.png) no-repeat 50%;}
.table-results tr:nth-child(odd){background:#fafaff;}

@media (max-width:640px){
    /*.table-results h5{float:none;margin-right:10px;position:absolute;right:0;}*/
    .table-results table{padding:0 10px;margin-top:25px;}
    .table-results table td{width:640px;padding:10px;}
    .table-results .filing-date,.table-results .owner,.table-results .title{text-align:left;}
    .table-results .filing-date{color:#7b848d;font-family:MontserratRegular;font-size:14px;line-height:24px;display:inline-block;vertical-align:top;}
    .table-results .one-line{text-align:left;margin-top:4px;}
    .table-results .status{display:inline-block;width:60px;height:22px;float:right;}
    .table-results .paging .wrapper{padding:5px!important;}
    .table-results .paging .MuiPaginationItem-root.MuiPaginationItem-page{margin-right:5px!important;}
}
.table-results .paging{text-align:center;margin-top:70px;}
.table-results .paging .wrapper{border:1px solid #ecedf1;box-sizing:border-box;border-radius:6px;display:inline-block;padding:22px;}
.table-results .paging .MuiPaginationItem-previousNext{display:inline-block;color:#a5aaaf;}
.table-results .paging .MuiPaginationItem-previousNext:hover{color:#f37217;}
.table-results .paging li:first-of-type .MuiPaginationItem-previousNext:after{content:"prev";color:#a5aaaf;margin-left:15px;font-family:MontserratRegular;font-size:14px;line-height:24px;}
.table-results .paging li:first-of-type .MuiPaginationItem-previousNext:hover:after,.table-results .paging li:last-of-type .MuiPaginationItem-previousNext:hover:before{color:#f37217;}
.table-results .paging li:last-of-type .MuiPaginationItem-previousNext:before{content:"next";color:#a5aaaf;margin-right:15px;}
.table-results .paging .MuiPaginationItem-root.MuiPaginationItem-page{color:#7b848d;font-family:MontserratBold;font-weight:700;font-size:16px;line-height:20px;display:inline-block;margin-right:15px;text-align:center;width:20px;}
.table-results .paging .MuiPaginationItem-root.Mui-selected{color:#03589c;font-family:MontserratBold;font-weight:700;font-size:16px;line-height:20px;border-bottom:3px solid #03589c;background-color:transparent;border-radius:0;}
.mobile{display:none!important;}
@media (max-width:640px){
    .desktop{display:none!important;}
    .mobile{display:block!important;}
}
/*! CSS Used from: Embedded */
@media (max-width: 768px){
    .iMAZZ .mobile{width:100%;}
}
/*! CSS Used from: Embedded */
.css-w0pj6f{overflow:hidden;pointer-events:none;position:absolute;z-index:0;inset:0px;border-radius:inherit;}
.css-nhb8h9, .pagination-container{display:flex;flex-wrap:wrap;-webkit-box-align:center;align-items:center;padding:0px;margin:0px;list-style:none;}
.css-1xr9krm, .paginate-buttons{display:inline-flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;position:relative;-webkit-tap-highlight-color:transparent;background-color:transparent;outline:0px;border:0px;cursor:pointer;user-select:none;vertical-align:middle;appearance:none;text-decoration:none;font-family:Roboto, Helvetica, Arial, sans-serif;font-weight:400;font-size:0.875rem;line-height:1.43;letter-spacing:0.01071em;border-radius:16px;text-align:center;box-sizing:border-box;min-width:32px;height:32px;padding:0px 6px;margin:0px 3px;color:rgba(0, 0, 0, 0.87);transition:color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;}
@media print{
    .css-1xr9krm, .paginate-buttons{-webkit-print-color-adjust:exact;}
}
.css-1xr9krm:hover, .paginate-buttons:hover{background-color:rgba(0, 0, 0, 0.04);}
@media (hover: none){
    .css-1xr9krm:hover, .paginate-buttons:hover{background-color:transparent;}
}
.css-1xr9krm.Mui-selected{background-color:rgba(0, 0, 0, 0.08);}
.css-1xr9krm.Mui-selected:hover{background-color:rgba(0, 0, 0, 0.12);}
@media (hover: none){
    .css-1xr9krm.Mui-selected:hover{background-color:rgba(0, 0, 0, 0.08);}
}
.css-lrb33l{user-select:none;width:1em;height:1em;display:inline-block;fill:currentcolor;flex-shrink:0;transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;font-size:1.25rem;margin:0px -8px;}
.css-16y9h98{font-family:Roboto, Helvetica, Arial, sans-serif;font-weight:400;font-size:0.875rem;line-height:1.43;letter-spacing:0.01071em;border-radius:16px;text-align:center;box-sizing:border-box;min-width:32px;padding:0px 6px;margin:0px 3px;color:rgba(0, 0, 0, 0.87);height:auto;}
/*! CSS Used from: Embedded */
.css-9l3uo3{margin:0;font-family:"Roboto","Helvetica","Arial",sans-serif;font-weight:400;font-size:1rem;line-height:1.5;letter-spacing:0.00938em;}
/*! CSS Used from: Embedded */
.css-9l3uo3{margin:0;font-family:"Roboto","Helvetica","Arial",sans-serif;font-weight:400;font-size:1rem;line-height:1.5;letter-spacing:0.00938em;}
/*! CSS Used from: Embedded */
.css-9l3uo3{margin:0;font-family:"Roboto","Helvetica","Arial",sans-serif;font-weight:400;font-size:1rem;line-height:1.5;letter-spacing:0.00938em;}
/*! CSS Used fontfaces */
@font-face{font-family:Open SansVariable;font-style:normal;font-display:swap;font-weight:300 800;src:url(https://trademark-genius.com/_next/static/media/open-sans-cyrillic-variable-wghtOnly-normal.fff15727.woff2) format("woff2");unicode-range:U+0400-045f,U+0490-0491,U+04b0-04b1,U+2116;}
@font-face{font-family:Open SansVariable;font-style:normal;font-display:swap;font-weight:300 800;src:url(https://trademark-genius.com/_next/static/media/open-sans-cyrillic-ext-variable-wghtOnly-normal.0dadfc54.woff2) format("woff2");unicode-range:U+0460-052f,U+1c80-1c88,U+20b4,U+2de0-2dff,U+a640-a69f,U+fe2e-fe2f;}
@font-face{font-family:Open SansVariable;font-style:normal;font-display:swap;font-weight:300 800;src:url(https://trademark-genius.com/_next/static/media/open-sans-greek-variable-wghtOnly-normal.90755a91.woff2) format("woff2");unicode-range:U+0370-03ff;}
@font-face{font-family:Open SansVariable;font-style:normal;font-display:swap;font-weight:300 800;src:url(https://trademark-genius.com/_next/static/media/open-sans-greek-ext-variable-wghtOnly-normal.a97d9cb2.woff2) format("woff2");unicode-range:U+1f??;}
@font-face{font-family:Open SansVariable;font-style:normal;font-display:swap;font-weight:300 800;src:url(https://trademark-genius.com/_next/static/media/open-sans-hebrew-variable-wghtOnly-normal.74fb4c9e.woff2) format("woff2");unicode-range:U+0590-05ff,U+200c-2010,U+20aa,U+25cc,U+fb1d-fb4f;}
@font-face{font-family:Open SansVariable;font-style:normal;font-display:swap;font-weight:300 800;src:url(https://trademark-genius.com/_next/static/media/open-sans-latin-variable-wghtOnly-normal.154dd445.woff2) format("woff2");unicode-range:U+00??,U+0131,U+0152-0153,U+02bb-02bc,U+02c6,U+02da,U+02dc,U+2000-206f,U+2074,U+20ac,U+2122,U+2191,U+2193,U+2212,U+2215,U+feff,U+fffd;}
@font-face{font-family:Open SansVariable;font-style:normal;font-display:swap;font-weight:300 800;src:url(https://trademark-genius.com/_next/static/media/open-sans-latin-ext-variable-wghtOnly-normal.6888923f.woff2) format("woff2");unicode-range:U+0100-024f,U+0259,U+1e??,U+2020,U+20a0-20ab,U+20ad-20cf,U+2113,U+2c60-2c7f,U+a720-a7ff;}
@font-face{font-family:Open SansVariable;font-style:normal;font-display:swap;font-weight:300 800;src:url(https://trademark-genius.com/_next/static/media/open-sans-vietnamese-variable-wghtOnly-normal.9cafbbcd.woff2) format("woff2");unicode-range:U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01a0-01a1,U+01af-01b0,U+1ea0-1ef9,U+20ab;}
@font-face{font-family:MontserratRegular;src:url(https://trademark-genius.com/_next/static/media/Montserrat-Regular.b274626d.woff) format("woff");}
@font-face{font-family:MontserratBold;src:url(https://trademark-genius.com/_next/static/media/Montserrat-Bold.b5135893.woff) format("woff");}
.uspto-block {
    border: 1px solid;
    padding: 20px;
    margin-bottom: 16px;
    overflow-x: auto;
}
</style>
<style>
.css-nhb8h9, .pagination-container{display:flex;flex-wrap:wrap;-webkit-box-align:center;align-items:center;padding:0px;margin:0px;list-style:none;}
.css-1xr9krm, .paginate-buttons{display:inline-flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;position:relative;-webkit-tap-highlight-color:transparent;background-color:transparent;outline:0px;border:0px;cursor:pointer;user-select:none;vertical-align:middle;appearance:none;text-decoration:none;font-family:Roboto, Helvetica, Arial, sans-serif;font-weight:400;font-size:0.875rem;line-height:1.43;letter-spacing:0.01071em;border-radius:16px;text-align:center;box-sizing:border-box;min-width:32px;height:32px;padding:0px 6px;margin:0px 3px;color:rgba(0, 0, 0, 0.87);transition:color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;}
@media print{
    .css-1xr9krm, .paginate-buttons{-webkit-print-color-adjust:exact;}
}
.css-1xr9krm:hover, .paginate-buttons:hover{background-color:rgba(0, 0, 0, 0.04);}
@media (hover: none){
    .css-1xr9krm:hover, .paginate-buttons:hover{background-color:transparent;}
}
.css-1xr9krm.Mui-selected, .active-page{background-color:rgba(0, 0, 0, 0.08);}
.css-1xr9krm.Mui-selected:hover, .active-page:hover{background-color:rgba(0, 0, 0, 0.12);}
@media (hover: none){
    .css-1xr9krm.Mui-selected:hover, .active-page:hover{background-color:rgba(0, 0, 0, 0.08);}
}
</style>
